import { bootstrapApplication } from "@angular/platform-browser"
import { AppComponent } from "app/app.component"
import { environment } from './environments/environment';
import { appConfig } from "app/app.config"
import Bugsnag from "@bugsnag/js"
import { reportLazyLoadError } from "common/lazy_load_error"

Bugsnag.start({apiKey: '9ab1641ac0c59056a83ee0daae7c2162', appVersion: environment.version, releaseStage: environment.stage, enabledReleaseStages: [ 'production', 'staging' ], onError: reportLazyLoadError })

declare global {
  // tslint:disable-next-line
  interface Window {
    WebFont: { load: (params: any) => void}
  }
}

bootstrapApplication(AppComponent, appConfig).then(() => {
  console.info('InfluxTV loaded 📺 💪', environment.version)
})
